import templateUrl from "emun.order/vendor-review-orders/vendor-review-order.htm";
import open from "webmodals/open";
import modals from "webmodals/modals";
import ServiceBus from 'servicestack/service-bus'
import basicController from "servicestack/basic.controller.properties";

class controller {
	constructor($scope, options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.bus = $ctrl.$session.bus;
		$ctrl.title = options.title || "Vendor Review Order...";
		$ctrl.order = options.order;
		$ctrl.request = {
			OrderNumber: $ctrl.order.id,
			RetailerId: $ctrl.order.retailerId,
			VendorId: $ctrl.order.vendorId,
			ShipId: $ctrl.order.shippingLocationId,
			VendorCustId: "",
			VendorShipId: "",
			ManualProcess: false
		};
		if ($ctrl.order.retailerId) {
			$ctrl.bus
				.send(
					`QueryRetailerVendors.json?fields=vendorId,vendorCustId&RetailerId=${$ctrl.order.retailerId}&VendorId=${$ctrl.order.vendorId}`,
					{
						op: "OrderHeaderFieldset",
					}
				)
				.then(function (response) {
					$ctrl.retailerVendors = response.data.results;
					if (response.data.results.length > 0) {
						$ctrl.request.VendorCustId = response.data.results[0].vendorCustId;
					}
				});
		}
		if ($ctrl.order.shippingLocationId && $ctrl.order.retailerId) {
			$ctrl.bus
				.send(
					`QueryRetailerVendorLocations.json?fields=vendorId,vendorShipId&RetailerId=${$ctrl.order.retailerId}&VendorId=${$ctrl.order.vendorId}&ShipId=${$ctrl.order.shippingLocationId}`,
					{
						op: "OrderHeaderFieldset",
					}
				)
				.then(function (response) {
					$ctrl.retailerVendorLocations = response.data.results;
					if (response.data.results.length > 0) {
						$ctrl.request.VendorShipId = response.data.results[0].vendorShipId;
					}
				});
		}
		$ctrl.submit = () => {
      if ($ctrl.request.ManualProcess && $ctrl.request.ManualProcessConfirm) {
        let busy = modals.busy(
          "Updating Order...",
          `Thank you for your patience as order ${$ctrl.request.OrderNumber} is updated.`
        );

        $ctrl.bus
          .send("VendorApproveOrder.json", $ctrl.request).then(function (response) {
              $ctrl.$close();
            })
          .finally(busy.close);
			} else {
				$ctrl.bus.send("VendorApproveOrder.json", $ctrl.request).then(function (response) {
					$ctrl.$close();
				});
			}
		};
	}

}

export default {
	open(options) {
		return modals.open(
			Object.assign(
				{
					templateUrl,
					resolve: {
						options: () => options
					},
					bindToController: true,
					controller,
					controllerAs: "$ctrl",
					size: "md"
				},
				(options || {}).modal
			)
		).result;
	}
};

